import { openDB } from 'idb';

// Pasta onde o programa da balança lê o arquivo de carga (ex.: C:\Filizola).
// O navegador não aceita gravar num caminho digitado: na 1ª exportação o
// operador escolhe a pasta (File System Access API, Edge/Chrome) e o handle
// fica guardado NESTE computador (IndexedDB) — as próximas exportações gravam
// direto lá, substituindo o arquivo. Sem suporte (Firefox etc.), cai no
// download normal.
const DB = 'erp-balanca';
const STORE = 'handles';
const CHAVE = 'pasta_carga';

const db = () => openDB(DB, 1, { upgrade(d) { d.createObjectStore(STORE); } });

export const suportaPastaDireta = () => typeof window !== 'undefined' && 'showDirectoryPicker' in window;

export async function pastaSalva() {
  try { return (await (await db()).get(STORE, CHAVE)) || null; } catch { return null; }
}

export async function escolherPasta() {
  const handle = await window.showDirectoryPicker({ id: 'pasta-balanca', mode: 'readwrite' });
  await (await db()).put(STORE, handle, CHAVE);
  return handle;
}

export async function esquecerPasta() {
  try { await (await db()).delete(STORE, CHAVE); } catch { /* sem IndexedDB: nada guardado */ }
}

// Pasta pronta pra gravar: a guardada (pedindo a permissão de novo, se o
// navegador zerou) ou uma escolhida agora. Chamar LOGO no clique, antes de
// qualquer await de rede — o navegador só abre o seletor/permite com o gesto
// do usuário ainda "fresco".
export async function prepararPasta() {
  let handle = await pastaSalva();
  if (handle && (await handle.requestPermission({ mode: 'readwrite' })) !== 'granted') handle = null;
  return handle || escolherPasta();
}

// Grava (substitui) o arquivo dentro da pasta.
export async function gravarArquivo(handle, nomeArquivo, conteudo) {
  const arq = await handle.getFileHandle(nomeArquivo, { create: true });
  const w = await arq.createWritable();
  await w.write(new Blob([conteudo], { type: 'text/plain;charset=us-ascii' }));
  await w.close();
}
